import { obterLocalizacoesAsync } from "../../services/localizacaoService";

const atualizarLocalizacoes = async ({ commit }) => {
    const localizacoes = await obterLocalizacoesAsync();
    commit('atualizarLocalizacoes', localizacoes);
}

const atualizarLocalizacao = ({ commit }, localizacao) => {
    commit('atualizarLocalizacao', localizacao);
}

const updateLocalizacao = ({ commit }, localizacao) => {
    commit('updateLocalizacao', localizacao);
}

export default {
    atualizarLocalizacoes,
    atualizarLocalizacao,
    updateLocalizacao
}